<script setup lang="ts">
type Props = {
  isMap?: boolean
  loading?: boolean
}

defineProps<Props>()

const emit = defineEmits(['onUpdateMethod'])
</script>

<template>
  <div class="address-system-dialog-error">
    <div class="address-system-dialog-error__title">
      <span v-if="!isMap">Не удалось загрузить адреса, попробуйте снова</span>
      <span v-else>Не удалось загрузить карту, попробуйте снова</span>
    </div>
    <the-button
      class="address-system-dialog-error__button"
      :loading="loading"
      variant="secondary"
      @click="emit('onUpdateMethod')"
    >
      Обновить
    </the-button>
  </div>
</template>

<style scoped lang="scss">
.address-system-dialog-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 28px;

  @include media('>tablet') {
    position: absolute;
    z-index: 2;
  }

  &__title {
    max-width: 335px;
    margin-bottom: 24px;
    font-size: 20px;
    font-weight: 800;
    line-height: 26px;
    color: var(--ui-color-sandy-950);
    text-align: center;
  }

  &__button {
    width: 240px;

    @include media('>tablet') {
      width: 180px;
    }
  }
}
</style>
